import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Declare gtag as a global function
declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

// Map routes to page titles
const PAGE_TITLES: Record<string, string> = {
    '/': 'Home - AI Cost Optimization Engine',
    '/login': 'Login',
    '/register': 'Create Account',
    '/docs': 'Documentation',
    '/profile/api-keys': 'API Keys',
    '/profile/billing': 'Billing & Usage',
    '/profile/finance': 'Financial Metrics',
    '/profile/devops': 'DevOps Dashboard',
    '/llm': 'LLM Access',
    '/free-testing': 'Free Model Testing',
    '/router-demo': 'Interactive Router Demo',
    '/verify-email': 'Verify Email',
    '/thanks': 'Thank You',
};

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // 1. Get the current path (e.g., "/profile/api-keys")
        const pathname = location.pathname;

        // 2. Determine the title
        // Simple matching first, could be enhanced with regex for dynamic routes if needed
        let title = PAGE_TITLES[pathname];

        // Fallback for sub-routes (e.g. /docs/intro -> matches /docs)
        if (!title) {
            // Check if it starts with a known prefix
            const matchingPrefix = Object.keys(PAGE_TITLES).find(prefix =>
                prefix !== '/' && pathname.startsWith(prefix)
            );
            if (matchingPrefix) {
                title = PAGE_TITLES[matchingPrefix];
            } else {
                title = 'AI Cost Optimization Engine'; // Default
            }
        }

        const fullTitle = `SigLLM - ${title}`;

        // 3. Update document title
        document.title = fullTitle;
    }, [location]);
};
